import { CoreFiltersController } from './core-filters.controller'

/* @ngInject */
function coreFilters () {
  return {
    restrict: 'E',
    scope: {
      filterParams: '=',
      filterItems: '<'
    },
    templateUrl: '/core/directives/core-filters/core-filters-directive.html?$$REVISION$$',
    controller: CoreFiltersController
  }
}

export { coreFilters }
